import { render, staticRenderFns } from "./ClinicComponent.vue?vue&type=template&id=d5baf012&scoped=true&"
import script from "./ClinicComponent.vue?vue&type=script&lang=js&"
export * from "./ClinicComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5baf012",
  null
  
)

export default component.exports